import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWorkPresetStore } from '../stores/useWorkPresetStore';
import { useConfigurationStore } from '../stores/useConfigurationStore';
import { WorkflowContainer } from '../components/configuration/WorkflowContainer';
import { createPresetCreationConfiguration } from '../components/configuration/presetCreationConfiguration';

export const PresetCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const { createPreset } = useWorkPresetStore();
  const { formData, submitConfiguration, resetForm } = useConfigurationStore();

  // Configuration을 안정적인 reference로 생성
  const configuration = useMemo(() => createPresetCreationConfiguration(), []);


  const handleComplete = async () => {
    try {
      await submitConfiguration();
      
      // formData에서 프리셋 정보 추출
      const presetName = formData.presetName as string;
      const presetDescription = formData.presetDescription as string;
      const presetTags = formData.presetTags as string[];
      
      // Job 설정 정보 추출
      const languageSettingsComponent = formData.languageSettingsComponent;
      const workflowComponent = formData.workflowComponent;
      const workerAssignmentComponent = formData.workerAssignmentComponent;
      const jobTags = formData.jobTags as string[];

      // 프리셋 생성
      const newPreset = {
        name: presetName,
        description: presetDescription,
        tags: presetTags, // string[] 형태
        configData: {
          languageSettingsComponent,
          workflowComponent,
          workerAssignmentComponent,
          jobTags
        },
        category: 'custom', // 기본값
        userInteraction: {
          isFavorite: false,
          lastUsedAt: null,
          usageCount: 0,
          rating: null
        },
        metadata: {
          statistics: {
            avgCompletionTime: 0,
            successRate: 0,
            totalUsage: 0
          },
          performance: {
            efficiency: 0,
            quality: 0,
            cost: 0
          },
          requirements: {
            minWorkers: 1,
            estimatedDuration: '1d',
            complexity: 'medium'
          }
        }
      };

      await createPreset(newPreset);
      
      console.log('프리셋 생성 완료:', newPreset);
      alert('프리셋이 성공적으로 생성되었습니다!');
      
      // 프리셋 관리 페이지로 이동
      navigate('/work/presets');
    } catch (error) {
      console.error('프리셋 생성 실패:', error);
      alert('프리셋 생성에 실패했습니다. 다시 시도해주세요.');
    }
  };

  const handleCancel = () => {
    const confirmed = window.confirm('작성 중인 내용이 있습니다. 정말 취소하시겠습니까?');
    if (confirmed) {
      resetForm();
      navigate('/work/presets');
    }
  };


  return (
    <div className="min-h-screen bg-gray-50">
      {/* 메인 콘텐츠 */}
      <div className="container mx-auto px-6 py-6">
        <WorkflowContainer
          workId="preset-creation"
          configuration={configuration}
          onComplete={handleComplete}
          onCancel={handleCancel}
          title="새 프리셋 생성"
          description="4단계를 통해 새로운 작업 프리셋을 생성합니다"
          showModeSelector={true}
          defaultViewMode="stepper"
          cancelButtonText="취소"
          completeButtonText="프리셋 생성 완료"
        />
      </div>
    </div>
  );
};